<template>
    <div class="app-container app-theme-white body-tabs-shadow fixed-header fixed-sidebar">
        <Menu />
        <div class="app-main" >
            <Main />
            <div class="app-main__outer">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<script>
    import Menu from '@/components/plantilla/Menu';
    import Main from '@/components/plantilla/Main';
    import Vuex from 'vuex';
    export default {
     name: 'Inicio',
     components:{
         Menu,
         Main,
     },
    data: () => ({
      //  institucion:null,
    }),
    computed:{
        ...Vuex.mapState(['institucion']),
    },
    methods:{
        ...Vuex.mapActions(['setInstitucion']),
    },
    created(){
        if(!JSON.parse(localStorage.getItem('institucion'))){
            this.$router.push({name: "ListarInstituciones"})
        }
    },
    mounted(){
    }
    
    }
</script>